import patientHcp from 'images/welcome/patient-hcp.jpg';
import whoCanJoinImage from 'images/welcome/family-2-stock.jpg';
import howToJoinImage from 'images/welcome/family-1-stock.jpg';
import whatToExpect from 'images/welcome/family-3-stock.jpg';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useCards = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));

  const cards = [
    {
      image: patientHcp,
      title: 'Why Join SOURCE',
      color: 'primary.navy',
      backgroundColor: 'primary.tealTint',
      list: [
        'You can contribute to discoveries in single ventricle that will lead to new, customized treatments and maybe even cures.',
        'There is no cost, no travel, and no time out of work or school required to participate.',
        'We are building a dataset to share with all researchers worldwide to fuel as much research as possible. SOURCE is actually not just one study, but many!',
        'You have an opportunity to meaningfully contribute to research that will transform the future for single ventricle patients – those alive today and those who are not yet born.',
      ],
      imageFirst: matches,
    },
    {
      image: whoCanJoinImage,
      title: 'Who Can Join',
      color: 'white',
      backgroundColor: 'primary.navy',
      list: [
        'Anyone living in the U.S. with a single ventricle heart defect and their immediate biological family members',
        'All ages and stages are welcome, from pre-Fontan to post-transplant',
      ],
      imageFirst: false,
    },
    {
      image: howToJoinImage,
      title: 'How to Join',
      color: 'primary.navy',
      backgroundColor: 'primary.mint',
      list: [
        'Create an account online',
        'Agree to share data and genetic information',
        'Answer questions about your health',
        'Share medical records about your heart if you have single ventricle',
        'Registration is simple and should take less than 30 minutes',
      ],
      imageFirst: matches,
    },
    {
      image: whatToExpect,
      title: 'What to Expect',
      color: 'primary.navy',
      backgroundColor: 'primary.green',
      list: [
        'Participation is online and free',
        'Your information will be kept private and secure',
        'Swab the inside of your cheek at home and return it in the mail to participate in genetic research',
        'We will keep you updated about research progress',
      ],
      imageFirst: false,
    },
  ];
  return cards;
};
